import { FontEntry } from '../../types/font'

export const classicGrotesquePro: FontEntry = {
  displayName: 'classic-grotesque-pro',
  weights: {
    300: {
      normal: { file: 'ClassicGrotesquePro-Light', extension: 'woff2', format: 'woff2' },
      italic: null
    },
    400: {
      normal: { file: 'ClassicGrotesquePro-Regular', extension: 'woff2', format: 'woff2' },
      italic: null
    },
    600: {
      normal: { file: 'ClassicGrotesquePro-SemiBold', extension: 'woff2', format: 'woff2' },
      italic: null
    }
  },
  fallbackMetrics: {
    arial: {
      regular: {
        sizeAdjust: 99.78,
        ascentOverride: 100.22,
        descentOverride: 35.58,
        lineGapOverride: 0
      },
      bold: {
        sizeAdjust: 95.86,
        ascentOverride: 101.08,
        descentOverride: 32.76,
        lineGapOverride: 0
      }
    },
    roboto: {
      regular: {
        sizeAdjust: 101.25,
        ascentOverride: 98.77,
        descentOverride: 35.06,
        lineGapOverride: 0
      },
      bold: {
        sizeAdjust: 101.56,
        ascentOverride: 95.41,
        descentOverride: 30.92,
        lineGapOverride: 0
      }
    }
  }
}
